import { render, staticRenderFns } from "./AppointmentSuccessful.vue?vue&type=template&id=4988a532&scoped=true"
import script from "./AppointmentSuccessful.vue?vue&type=script&lang=js"
export * from "./AppointmentSuccessful.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSuccessful.vue?vue&type=style&index=0&id=4988a532&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4988a532",
  null
  
)

export default component.exports